import React from "react";
import {Box} from "@mui/material";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import type {NodeViewProps} from "@tiptap/react";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import FieldView from "./FieldView";
import {getFieldAttrs} from "./printoutFieldOptions";
import type {PrintoutFieldAttrs} from "./printoutFieldOptions";

const PrintoutFieldNodeView = (props: NodeViewProps) => {
    const attrs = getFieldAttrs(props.node.attrs as PrintoutFieldAttrs);

    return (
        <PrintoutBlockShell
            {...props}
            blockType="printoutField"
            icon={<DrawOutlinedIcon fontSize="small"/>}
            label="Field"
        >
            <Box className="printout-field" sx={{width: "100%"}}>
                <FieldView attrs={attrs}/>
            </Box>
        </PrintoutBlockShell>
    );
};

export default PrintoutFieldNodeView;
